//group events by location and type
import {EventTypes} from "../types";

export const groupEvents = (data : EventTypes.Model[], groupByKey: 'latLngString' | 'latLngStringApprox')=>{
    const grouped = data.reduce((result: any, item) => {

        const primaryKey = item[groupByKey]!;
        const secondaryKey  = item.type!;

        if (!result[primaryKey]) {
            result[primaryKey] = {
                events: {},
                isMultiple: false // Initialize as false
            };
        }

        if (!result[primaryKey].events[secondaryKey]) {
            result[primaryKey].events[secondaryKey] = [];
        }

        result[primaryKey].events[secondaryKey].push(item);
        return result;
    }, {});

    // Calculate isMultiple flag for each department
    Object.keys(grouped).forEach(department => {
        const locationCount = Object.keys(grouped[department].events).length;
        grouped[department].isMultiple = locationCount > 1;
    });

    //some events don't have addressLocation field, these are grouped in null key so need to remove that
    if(grouped?.hasOwnProperty('null'))
        delete grouped['null']
    return grouped;
}

export const hasMultipleEvents = (address : string, groupByEvents : any)=>{
    if(!groupByEvents)
        return false;
    return groupByEvents[address]?.isMultiple;
}

export const containsMultipleEvents = (groupByEvents : any)=>{
    if(!groupByEvents)
        return false;
    let counter = 0;
    Object.entries(groupByEvents).forEach(([key, value] : [string, any]) => {
       if(value?.isMultiple){
           counter++;
       }
    });
    return counter > 0;
}



export const getMultipleEvents = (address : string, groupByEvents : any) : EventTypes.Model[] | null =>{
    if(!groupByEvents)
        return null
    let result : EventTypes.Model[] = [];
    let multipleEvents =  groupByEvents[address]?.events;
    if(!!multipleEvents){
        Object.keys(multipleEvents)?.map((eventKey)=>{
            result.push(...multipleEvents[eventKey]);
        })
    }
    return result;
}

export const getMarkerType = (event : EventTypes.Model,  groupByKey: 'latLngString' | 'latLngStringApprox', groupByEvents : any) =>{
    let isMultiple = hasMultipleEvents(event[groupByKey]!,groupByEvents);
    let key = event?.type!
    if(!isMultiple)
        return key;
    let multipleEvents = getMultipleEvents(event[groupByKey]!,groupByEvents);
    if(isMultiple && containsAlertEvent(multipleEvents!))
        return 'alert';
    else
        return 'multiple'
}

export const containsAlertEvent = (events : EventTypes.Model[]) : boolean =>{
    let alertEvent = events?.filter(event=> event.type === 'alert')
    return !!alertEvent?.length
}